<template>
  <div class="white-bg">
    <div class="profile-user flex flex-wrap justify-center mx3">
      <div class="col-12 flex justify-center items-center">
        <UserPhoto style="width: 60px; height: 60px; min-width: 60px; min-height: 60px;"></UserPhoto>
        <span class="profile-name blue pl2 h3n bold">{{ user.firstname }} {{ user.lastname }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

import UserPhoto from '@/components/elements/UserPhoto';

export default {
  setup () {
    const store = useStore();
    const user = computed(() => store.state.user)

    return { user }
  },
  components: {
    UserPhoto
  }
};
</script>

<style scoped>

.profile-name {
  text-align: left;
}

.profile-user {
  background-color: white;
  border-bottom: 2px solid #00a6c6;
  height: 80px;
  min-height: 80px;
}

</style>
